import { opsConstants  } from "../constants/ops.constants";

export function ops(state = { creating: false }, action) {
    switch (action.type) {
      case opsConstants.AIRTABLE_RECONCILIATION_REPORT_REQUEST:
        return {
          ...state,
          isLoading: true,
        };
      case opsConstants.AIRTABLE_RECONCILIATION_REPORT_SUCCESS:
        return {
          ...state,
          airtable_reconciliation_report: action.report,
          isLoading: false,
        };
      case opsConstants.AIRTABLE_RECONCILIATION_REPORT_FAILURE:
        return {
          ...state,
          error: action.error,
          isLoading: false,
        };
      default:
        return state;
    }
  }
  